export enum Lang {
    it = 'it',
    en = 'en'
}